import { z } from 'zod';
import { IObject } from '../IObject';
import { requiredString, coerceNumber } from '../../validation';

export const EbpCaseExpertUpsertNoteSchema = z.object({
  note: requiredString('Note is required').max(5000),
  timeTakenInMinutes: coerceNumber(
    z
      .number('Time taken is required')
      .min(1, "Time taken can't be less than 1 minute")
      .max(1000, "Time taken can't be more than 1000 minutes"),
  ),
});

export const EbpCaseExpertInternalNoteDataSchema =
  EbpCaseExpertUpsertNoteSchema.extend({
    expertId: z.string().min(1).max(150),
  });

export type EbpCaseExpertUpsertNote = z.infer<
  typeof EbpCaseExpertUpsertNoteSchema
>;

export type EbpCaseExpertInternalNoteData = z.infer<
  typeof EbpCaseExpertInternalNoteDataSchema
>;
export type EbpCaseExpertInternalNote =
  IObject.HasIdTimestamped<EbpCaseExpertInternalNoteData>;
